import React from "react"
import { Controller, Control } from "react-hook-form"
import { graphql } from "gatsby"
import Optional from "./form-optional-label"

export const query = graphql`
  fragment FormInputRadio on DatoCmsFormInputRadio {
    id
    options
    name
    label
    required
    model {
      apiKey
    }
  }
`

export interface FormInputRadio extends Queries.FormInputRadioFragment {
  control: Control
  columns?: number
}

type FormInputRadioProps = Omit<FormInputRadio, "id">

const FormInputRadio = ({
  columns = 1,
  control,
  label,
  name,
  options,
  required,
}: FormInputRadioProps) => {
  const allOptions: string[] = JSON.parse(options)
  return (
    <fieldset className="o-form__item c-form__fieldset">
      <legend className="c-form__fieldset__legend">
        {label} {!required && <Optional />}
      </legend>
      <div className={"o-form__columns-" + columns}>
        {allOptions.map((option: string) => {
          return (
            <Controller
              control={control}
              key={option}
              name={name}
              rules={{ required: true }}
              render={({ field: { onChange } }) => {
                return (
                  <div className="c-form__radio" key={option}>
                    <input
                      className="c-form__radio__input"
                      type="radio"
                      name={name}
                      id={name + option}
                      onChange={onChange}
                      value={option}
                      required={true}
                    />
                    <label
                      className="c-form__radio__label"
                      htmlFor={name + option}
                      dangerouslySetInnerHTML={{ __html: option }}
                    ></label>
                  </div>
                )
              }}
            />
          )
        })}
      </div>
    </fieldset>
  )
}

export default FormInputRadio
